/*******************************************************************************
 * Copyright (c) 2024-2026 Malond Limited. All rights reserved.
 * The source code is the property of Malond Limited.
 ******************************************************************************/

import useSWR from "swr"
import { useRouter } from "next/router"
import { useAuthReady } from "./useAuthReady"
import {
  Enterprise,
  ResponseEnterpriseGetList,
  ResponseEnterpriseGetOne,
} from "../libs/api/backend/src"
import {
  UrlEnterpriseGetListAPI,
  UrlEnterpriseGetOneAPI,
} from "../libs/api/url"

export function useMainEnterpriseId(): string {
  let enterpriseId = ""

  try {
    const router = useRouter()
    enterpriseId =
      (router.query.mainEnterpriseId as string) ||
      (router.query.enterpriseId as string) ||
      ""
  } catch (err) {
    console.error(err)
  }

  return enterpriseId
}

export function useEnterpriseGetOne(enterprise_id?: string) {
  const { isAuthenticated, authLoading } = useAuthReady()
  const { data: apiResponse, error } = useSWR<ResponseEnterpriseGetOne>(
    isAuthenticated && enterprise_id
      ? UrlEnterpriseGetOneAPI(enterprise_id)
      : null
  )

  const enterprise = apiResponse && (apiResponse.data as Enterprise)

  return {
    enterprise: apiResponse && enterprise ? enterprise : null,
    isLoading: Boolean(
      authLoading ||
      (isAuthenticated && enterprise_id && !error && !apiResponse)
    ),
    isError:
      error ||
      (apiResponse && !apiResponse.success
        ? apiResponse.errorMessage
        : undefined),
  }
}

export function useEnterpriseGetList() {
  const { isAuthenticated, authLoading } = useAuthReady()
  const { data: apiResponse, error } = useSWR<ResponseEnterpriseGetList>(
    isAuthenticated ? UrlEnterpriseGetListAPI() : null
  )

  const enterprises = apiResponse && (apiResponse.data as Array<Enterprise>)

  return {
    enterprises: apiResponse?.data ?? null,
    isLoading: Boolean(
      authLoading || (isAuthenticated && !error && !apiResponse)
    ),
    isError:
      error ||
      (apiResponse && !apiResponse.success
        ? apiResponse.errorMessage
        : undefined),
  }
}
